import { FC, ReactNode } from 'react'
import { TagsNoRef, ToReferences } from '../../types'
import { Icon, IconProps, IconPropsReferences } from '../../icons/Icon'

import { propsWithClassNames, trueOrUndefined } from '../../functions'

import {
  aside,
  header,
  main,
  title as titleStyle,
  description as descriptionStyle,
  icon as iconStyle,
  HeaderVariants,
  AsideStyle,
  iconPad,
  inner
} from './style.css'

type VNodes = {
  titleRef: HTMLHeadingElement
  descriptionRef: HTMLDivElement
  headerRef: HTMLElement
  innerRef: HTMLElement
  mainRef: HTMLElement
  suffixRef: HTMLElement
}

type References = Partial<
  ToReferences<VNodes> & { iconRefs: IconPropsReferences }
>

type ElementProps = {
  headerProps?: TagsNoRef<'header'>
  innerProps?: TagsNoRef<'section'>
  mainProps?: TagsNoRef<'main'>
  titleProps?: TagsNoRef<'h6'>
  descriptionProps?: TagsNoRef<'div'>
  suffixProps?: TagsNoRef<'aside'>
}

type StyleProps = HeaderVariants & {
  suffixStyle?: AsideStyle
}

type DataProps = {
  title?: ReactNode
  description?: ReactNode
  icon?: IconProps['namespace'] | null
  suffix?: ReactNode
}

export type BannerProps = ElementProps & References & DataProps & StyleProps

export const Banner: FC<BannerProps> = ({
  icon = 'Warning',
  suffix = [],
  descriptionProps,
  titleProps,
  headerProps,
  mainProps,
  suffixProps,
  suffixStyle = 'flex',
  headerRef,
  iconRefs,
  mainRef,
  suffixRef,
  titleRef,
  descriptionRef,
  title,
  description,
  innerProps,
  innerRef,
  ...headerVariants
}) => (
  <header
    ref={headerRef}
    role="banner"
    {...propsWithClassNames(headerProps, header(headerVariants))}
  >
    <section
      ref={innerRef}
      data-has-icon={trueOrUndefined(!!icon)}
      {...propsWithClassNames(innerProps, inner)}
    >
      {!!icon && (
        <figure className={iconPad}>
          <Icon namespace={icon} className={iconStyle} {...iconRefs} />
        </figure>
      )}

      <main ref={mainRef} {...propsWithClassNames(mainProps, main)}>
        {title && (
          <h6 ref={titleRef} {...propsWithClassNames(titleProps, titleStyle)}>
            {title}
          </h6>
        )}
        {description && (
          <div
            ref={descriptionRef}
            {...propsWithClassNames(descriptionProps, descriptionStyle)}
          >
            {description}
          </div>
        )}
      </main>

      <aside
        ref={suffixRef}
        {...propsWithClassNames(suffixProps, aside[suffixStyle])}
        children={suffix}
      />
    </section>
  </header>
)

export default Banner
